module.exports = __webpack_public_path__ + "media/tips/04_tri_dessin-cece1a51.png";